import { Expose } from 'class-transformer';

export class ReturnsProcessConfigResponseDto {
    /**
     * Returns process configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Does Client have a NO RETURN Policy?
     * @example true
     */
    @Expose()
    hasNoReturnPolicy?: boolean;

    /**
     * Is the 3PL/Warehouse's Returns Form Used?
     * @example true
     */
    @Expose()
    usesWarehouseReturnsForm?: boolean;

    /**
     * Comments for NO RETURN Policy
     * @example 'Potential return to stock after assessment by Q&C. Note no return to stock is permitted for sterile products.'
     */
    @Expose()
    noReturnPolicyComments?: string;

    /**
     * Comments for 3PL/Warehouse Returns Form
     * @example 'For a potential return to stock, Q&C uses Returned Product Form QR-022, using Lynden Product Return Inspection Report W-022 as a supporting document.'
     */
    @Expose()
    warehouseReturnsFormComments?: string;

    /**
     * Notes
     * @example 'Where a temperature excursion (or potential excursion) is associated with the return, refer to Section 3.7 of this client information record.'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    updatedAt: Date;
}
